import React from 'react';
import { Text } from '@blueprint/ui';
import { Container, Heading } from './TenancyInfo.styles';
import { TenancyInfoProps } from './TenancyInfo.types';

const TenancyInfo = ({ data }: TenancyInfoProps) => {
    return (
        <Container data-testid="tenancy-information-container">
            <Heading isRegular size="3">
                Tenancy information
            </Heading>
            <Text
                dangerouslySetInnerHTML={{
                    __html: data.administrationFees || ''
                }}
            ></Text>
        </Container>
    );
};

export default TenancyInfo;
